class BlockServices {
	constructor() {
		this.services = document.querySelector(".section-block-services");

		if (!this.services) {
			return;
		}

		const links = this.services.querySelectorAll("nav a");
		this.imageSwap(links);

		window.addEventListener("mousemove", (e) => {
			this.mouseInteraction(e, this.services.querySelector(".inner"), 0.05);
		});
	}

	imageSwap(links) {
		links.forEach(link => {
			const targetImage = this.services.querySelector("img[data-index='"+link.dataset.index+"']");

			link.addEventListener("mouseenter", () => {
				gsap.to(targetImage, {
					autoAlpha: 1,
					duration: 1
				});
			});

			link.addEventListener("mouseleave", () => {
				gsap.to(targetImage, {
					autoAlpha: 0,
					duration: 1
				});
			});
		});
	}

	mouseInteraction(e, elem, factor = 0.02) {
		const percentX = e.pageX - (window.innerWidth / 2);
		const percentY = e.pageY - (window.innerHeight);

		gsap.to(elem, {
			duration: 0.75,
			x: percentX * factor,
			y: percentY * factor,
			overwrite: true
		});
	}
}